import { PrimaryButton } from "@/components/button/primaryButton";
import { Merchant } from "@/dto/merchant";
import Image from "next/image";
import { ModalText } from "./welcomeModalText";
import { BottomModal } from "@/components/modals/modals";
import { cloverColorTheme } from "@/utils/cloverColorTheme";
import pom from "@/utils/pom";
import { applyDataTestId } from "@/utils/testUtils";
import { useTranslations } from "next-intl";
import { useId } from "react";

export interface RunningTabsWelcomeModalProps {
  merchant: Merchant;
  isOpen: boolean;
  onRequestClose: () => void;
}
export const RunningTabsWelcomeModal = ({
  merchant,
  isOpen,
  onRequestClose,
}: RunningTabsWelcomeModalProps) => {
  const t = useTranslations("RunningTabsWelcomeModal");
  const merchantLogo = merchant?.logo;
  const merchantColor =
    merchant?.merchantMeta?.colorPalette?.color ||
    cloverColorTheme.Main.primaryColor;
  const merchantName = merchant?.name;
  const titleId = useId();
  const subtitleId = useId();

  return (
    <BottomModal
      overlayClassName="bg-opacity-75"
      onRequestClose={onRequestClose}
      isOpen={isOpen}
      contentClassName="flex flex-col relative bg-white rounded-lg shadow-lg w-full max-w-full h-[92%] sm:h-auto sm:w-auto pt-4 sm:p-4 items-center sm:max-w-[645px]"
      aria={{ labelledby: titleId, describedby: subtitleId }}
    >
      <div
        data-testid={applyDataTestId(pom.scanToOrder.runningTabsWelcomeModal)}
        className="flex px-4 flex-col flex-1 items-center gap-6 pb-4"
      >
        <h2
          id={titleId}
          aria-describedby={subtitleId}
          className="text-sm sm:text-3xl justify-center text-center font-semibold text-[#373737] max-w-[80%] sm:max-w-[90%]"
        >
          {t("welcome", { merchantName })}
        </h2>
        {merchantLogo && (
          <Image
            className="w-20 h-20"
            src={merchantLogo}
            width={80}
            height={80}
            alt={t("logoAlt")}
          />
        )}
        <ModalText subtitleId={subtitleId} />
      </div>
      <PrimaryButton
        style={{ backgroundColor: merchantColor }}
        className="h-16 w-full sm:max-w-[320px] rounded-none sm:rounded-md text-xl"
        onClick={onRequestClose}
      >
        {t("continue")}
      </PrimaryButton>
    </BottomModal>
  );
};
